import { Modal } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import {
  type IApprovalReminderFormProps,
  ApprovalReminderForm,
} from './ApprovalReminderForm'
import messages from './messages'

export interface IApprovalReminderFormModalProps
  extends IApprovalReminderFormProps {
  reference?: string
  open?: boolean
}

export const ApprovalReminderFormModal = ({
  open = false,
  reference,
  onCancel,
  ...ApprovalReminderFormProps
}: IApprovalReminderFormModalProps) => {
  const intl = useProcurifyIntl()

  return (
    <Modal
      aria-labelledby='ApprovalReminderForm-modal-title'
      maxWidth='sm'
      open={open}
      onClose={onCancel}
      disableEnforceFocus
    >
      <Modal.Card>
        <Modal.Header id='ApprovalReminderForm-modal-title' onClose={onCancel}>
          {intl.formatMessage(messages.modalTitle)}
          {reference ? ` - ${reference}` : ''}
        </Modal.Header>
        <Modal.Content>
          <ApprovalReminderForm
            onCancel={onCancel}
            {...ApprovalReminderFormProps}
          />
        </Modal.Content>
      </Modal.Card>
    </Modal>
  )
}

ApprovalReminderFormModal.displayName = 'ApprovalReminderFormModal'
